import { render, staticRenderFns } from "./upper1MasterLower4Slave1Sun.vue?vue&type=template&id=6c194240&scoped=true&"
import script from "./upper1MasterLower4Slave1Sun.vue?vue&type=script&lang=js&"
export * from "./upper1MasterLower4Slave1Sun.vue?vue&type=script&lang=js&"
import style0 from "./upper1MasterLower4Slave1Sun.vue?vue&type=style&index=0&id=6c194240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c194240",
  null
  
)

export default component.exports